import { Typography } from 'antd';
import type { CommonTaskCardProps } from '../../types';
import styles from '../../AppHelpCenter.module.scss';
import { getHelpCenterIcon } from '../../utils';
import { ChevronRightIcon } from '@/assets/icons/icons';

const CommonTaskCard = ({ task, onSelect }: CommonTaskCardProps) => {
  return (
    <button
      type='button'
      className={styles.commonTaskCard}
      onClick={() => onSelect(task)}
    >
      <span className={styles.commonTaskIcon}>
        {getHelpCenterIcon('task', task.icon)}
      </span>
      <Typography.Text
        className={styles.commonTaskTitle}
        ellipsis={{ tooltip: task.title }}
      >
        {task.title}
      </Typography.Text>
      <span className={styles.commonTaskChevron}>
        <ChevronRightIcon width={16} height={16} fill='currentColor' />
      </span>
    </button>
  );
};

export default CommonTaskCard;
